import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import { Lock, Mail } from "lucide-react";

export default function PlatformLocked() {
    const { user } = useAuth();
    return (
        <div className="min-h-screen bg-paper">
            <Navbar />
            <main className="max-w-2xl mx-auto px-6 py-20">
                <div className="panel p-10 text-center">
                    <Lock size={36} className="text-orange mx-auto" strokeWidth={1.5} />
                    <div className="label-eyebrow mt-4">Plateforme verrouillée</div>
                    <h1 className="h-display text-3xl font-semibold mt-2">L'abonnement formateur n'est pas encore activé.</h1>
                    <p className="text-sm text-ink/70 mt-4 leading-relaxed">
                        Bonjour <strong>{user?.prenom || user?.email}</strong>, votre compte est créé mais aucun responsable de formation de votre établissement n'a encore activé l'abonnement Profawz pour votre lycée.
                    </p>
                    <div className="mt-8 panel p-5 bg-surface text-left">
                        <div className="label-eyebrow mb-2">Que faire ?</div>
                        <ol className="text-sm space-y-2 list-decimal list-inside text-ink/80">
                            <li>Demandez à votre <strong>responsable formation</strong> ou un <strong>formateur référent</strong> d'activer la plateforme.</li>
                            <li>Indiquez-lui de créer un compte <strong>Formateur</strong> et de souscrire à l'abonnement.</li>
                            <li>Une fois activé, vous pourrez soumettre votre bilan immédiatement.</li>
                        </ol>
                    </div>
                    <div className="mt-6 flex items-center gap-2 justify-center text-xs font-mono text-muted2">
                        <Mail size={13} /> Besoin d'aide ? contact@profawz.fr
                    </div>
                    <Link to="/dashboard" className="btn-outline mt-8 inline-flex" data-testid="locked-back-link">
                        Retour
                    </Link>
                </div>
            </main>
        </div>
    );
}
